import { render } from "./SeapVsSicap.vue?vue&type=template&id=bb7be978"
import script from "./SeapVsSicap.vue?vue&type=script&lang=js"
export * from "./SeapVsSicap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__